import { Helper } from '../Common/Helpers/helper';
import { Observable } from 'rxjs';

export class VisibaAudioAnalyser {
	bufferedSound: any = null;
	audioCtx: any = null;
	analyser: any = null;
	canvasCtx: any = null;
	source: any = null;

	constructor(private audioElement: HTMLAudioElement, private circlesContainer: HTMLElement, private _helper: Helper) {}

	init() {
		this.audioCtx = new ((<any>window).AudioContext || (<any>window).webkitAudioContext)();
		this.analyser = this.audioCtx.createAnalyser();
		this.analyser.minDecibels = -90;
		this.analyser.maxDecibels = -10;
		this.analyser.smoothingTimeConstant = 0.85;

		if (/^((?!chrome).)*safari/i.test(navigator.userAgent)) {
			// Bugger sound
			var request = new XMLHttpRequest();
			request.open('GET', '/Images/Public/soundtest.mp3', true);
			request.responseType = 'arraybuffer';
			request.addEventListener(
				'load',
				event => {
					this.bufferedSound = this.audioCtx.createBuffer(request.response, false);
				},
				false,
			);
			request.send();
		} else {
			// Creating audioContext makes sinkId not work! : 2018-09-04
			this.source = this.audioCtx.createMediaElementSource(this.audioElement);
			this.connectAnalyser();
		}
	}

	connectAnalyser() {
		this.source.connect(this.analyser);
		this.analyser.connect(this.audioCtx.destination);
	}

	start() {
		if (/^((?!chrome).)*safari/i.test(navigator.userAgent)) {
			this.source = this.audioCtx.createBufferSource();
			this.source.buffer = this.bufferedSound;
			this.connectAnalyser();
			this.source.noteOn(0);
			this.source.onended = () => {
				this.stop();
			};
		}

		this.analyser.fftSize = 64;
		var binCount = this.analyser.frequencyBinCount;
		var frequencyData = new Uint8Array(binCount);
		var max = 256;
		var minAnimCircleSize = 0.4;

		var circles = [];
		for (var i = 0; i < binCount; i++) {
			var node = document.createElement('div');
			node.classList.add('circle');
			circles.push(node);
			this.circlesContainer.appendChild(node);
		}

		let draw = () => {
			if (!this.audioElement.paused) window.requestAnimationFrame(draw);
			else while (this.circlesContainer.firstChild) this.circlesContainer.removeChild(this.circlesContainer.firstChild);

			this.analyser.getByteFrequencyData(frequencyData);

			for (var i = 0; i < circles.length; i++) {
				var circle = circles[i];
				circle.style.cssText =
					'transform:scale(' +
					((frequencyData[i] / 255) * (1 - minAnimCircleSize) + minAnimCircleSize) +
					');-webkit-transform:scale(' +
					((frequencyData[i] / max) * (1 - minAnimCircleSize) + minAnimCircleSize) +
					')';
			}
		};
		window.requestAnimationFrame(draw);
		return;
	}

	stop() {
		if (/^((?!chrome).)*safari/i.test(navigator.userAgent)) {
			this.source.stop(0);
			this.source = null;
		} else this.audioElement.pause();

		return;
	}
}

export module MediaTest {
	export function checkTURNServers(iceServers: any, timeout: number = 5000): Observable<boolean> {
		return Observable.create(observer => {
			var promiseResolved = false,
				myPeerConnection = window['RTCPeerConnection'] || window['mozRTCPeerConnection'] || window['webkitRTCPeerConnection'], //compatibility for firefox and chrome
				pc = new myPeerConnection({ iceServers: iceServers }),
				noop = () => {};

			pc.createDataChannel(''); //create a bogus data channel
			pc.createOffer(sdp => {
				if (sdp.sdp.indexOf('typ relay') > -1) {
					// sometimes sdp contains the ice candidates...
					promiseResolved = true;
					pc.close();
					observer.next(true);
				}
				pc.setLocalDescription(sdp, noop, noop);
			}, noop); // create offer and set local description
			pc.onicecandidate = ice => {
				//listen for candidate events
				if (
					promiseResolved ||
					!ice ||
					!ice.candidate ||
					!ice.candidate.candidate ||
					!(ice.candidate.candidate.indexOf('typ relay') > -1)
				)
					return;
				promiseResolved = true;
				pc.close();
				observer.next(true);
			};

			window.setTimeout(() => {
				if (promiseResolved) return;
				observer.next(false);
				pc.close();
				promiseResolved = true;
			}, timeout);
		});
	}
}
